import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, ViewChild, NgModule } from '@angular/core';
import * as i2 from '@angular/forms';
import { ControlContainer, NgForm, FormsModule } from '@angular/forms';
import intlTelInput from 'intl-tel-input';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';

/*
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
class IntlTelInputComponent {
    constructor() {
        this.name = 'intl-tel-input-name';
        this.options = {};
        this.E164PhoneNumberChange = new EventEmitter();
    }
    static modifyCountryData() {
        window.intlTelInputGlobals.getCountryData().forEach((country) => country.name = country.name.replace(/.+\((.+)\)/, '$1'));
    }
    ngAfterViewInit() {
        if (this.onlyLocalized) {
            IntlTelInputComponent.modifyCountryData();
        }
        const intlTelInputInstance = intlTelInput;
        this._intlTelInput = intlTelInputInstance(this._inputElement.nativeElement, this.options);
    }
    get intlTelInput() {
        return this._intlTelInput;
    }
    get phoneNumber() {
        return this._phoneNumber;
    }
    set phoneNumber(value) {
        if (!!value) {
            this._intlTelInput.setNumber(value);
        }
        this._phoneNumber = value;
        this.i18nizePhoneNumber();
    }
    i18nizePhoneNumber() {
        this.E164PhoneNumber = null;
        if (this._intlTelInput.isValidNumber()) {
            this.E164PhoneNumber = this._intlTelInput.getNumber();
        }
        this.E164PhoneNumberChange.emit(this.E164PhoneNumber);
    }
}
IntlTelInputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.0", ngImport: i0, type: IntlTelInputComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
IntlTelInputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.0", type: IntlTelInputComponent, selector: "intl-tel-input", inputs: { cssClass: "cssClass", E164PhoneNumber: "E164PhoneNumber", label: "label", labelCssClass: "labelCssClass", name: "name", onlyLocalized: "onlyLocalized", options: "options", required: "required" }, outputs: { E164PhoneNumberChange: "E164PhoneNumberChange" }, viewQueries: [{ propertyName: "_inputElement", first: true, predicate: ["intlTelInput"], descendants: true }], ngImport: i0, template: "<label [attr.for]=\"name\" [ngClass]=\"labelCssClass\" *ngIf=\"label && name\" >{{label}}</label>\n<input\n    type=\"text\"\n    [ngClass]=\"cssClass\"\n    [attr.id]=\"name\"\n    [attr.name]=\"name\"\n    [name]=\"name\"\n    [attr.aria-required]=\"required || null\"\n    [required]=\"required\"\n    [(ngModel)]=\"phoneNumber\"\n    (countrychange)=\"i18nizePhoneNumber()\"\n    #intlTelInput>\n\n", styles: [""], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], viewProviders: [{ provide: ControlContainer, useExisting: NgForm }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.0", ngImport: i0, type: IntlTelInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'intl-tel-input', viewProviders: [{ provide: ControlContainer, useExisting: NgForm }], template: "<label [attr.for]=\"name\" [ngClass]=\"labelCssClass\" *ngIf=\"label && name\" >{{label}}</label>\n<input\n    type=\"text\"\n    [ngClass]=\"cssClass\"\n    [attr.id]=\"name\"\n    [attr.name]=\"name\"\n    [name]=\"name\"\n    [attr.aria-required]=\"required || null\"\n    [required]=\"required\"\n    [(ngModel)]=\"phoneNumber\"\n    (countrychange)=\"i18nizePhoneNumber()\"\n    #intlTelInput>\n\n" }]
        }], propDecorators: { cssClass: [{
                type: Input
            }], E164PhoneNumber: [{
                type: Input
            }], label: [{
                type: Input
            }], labelCssClass: [{
                type: Input
            }], name: [{
                type: Input
            }], onlyLocalized: [{
                type: Input
            }], options: [{
                type: Input
            }], required: [{
                type: Input
            }], E164PhoneNumberChange: [{
                type: Output
            }], _inputElement: [{
                type: ViewChild,
                args: ['intlTelInput']
            }] } });

/*
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
class IntlTelInputNgModule {
    static forRoot() {
        return {
            ngModule: IntlTelInputNgModule,
            providers: []
        };
    }
}
IntlTelInputNgModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.0", ngImport: i0, type: IntlTelInputNgModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IntlTelInputNgModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.0", ngImport: i0, type: IntlTelInputNgModule, declarations: [IntlTelInputComponent], imports: [CommonModule,
        FormsModule], exports: [IntlTelInputComponent] });
IntlTelInputNgModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.0", ngImport: i0, type: IntlTelInputNgModule, imports: [CommonModule,
        FormsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.0", ngImport: i0, type: IntlTelInputNgModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        IntlTelInputComponent,
                    ],
                    imports: [
                        CommonModule,
                        FormsModule,
                    ],
                    exports: [
                        IntlTelInputComponent,
                    ]
                }]
        }] });

/*
 * Public API Surface of intl-tel-input-ng
 */

/**
 * Generated bundle index. Do not edit.
 */

export { IntlTelInputComponent, IntlTelInputNgModule };
//# sourceMappingURL=intl-tel-input-ng.mjs.map
